import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  CryptotokenKeyDataActions,
  CryptotokenKeyDataPipes,
  CryptotokenKeyDataSelectors,
  CryptotokenKeyDeleteActions,
  CryptotokenKeyDeleteSelectors,
} from './cryptotoken-keys.feature';
import { map, Observable } from 'rxjs';
import { PageDataState } from '../../page-data/page-data.types';
import { CryptotokenKey } from 'src/app/shared/entities/cryptotoken-key';

const Pipes = CryptotokenKeyDataPipes;
const Actions = CryptotokenKeyDataActions;
const Selectors = CryptotokenKeyDataSelectors;

@Injectable({
  providedIn: 'root',
})
export class CryptotokenKeyDataService {
  private store = inject(Store);

  data$: Observable<CryptotokenKey[] | null> = this.store.pipe(
    Pipes.selectData,
    map(data => data ?? []),
  );

  isLoading$: Observable<boolean> = this.store.select(
    Selectors.selectIsLoading,
  );

  isLoaded$: Observable<boolean> = this.store.select(Selectors.selectIsLoaded);
  isError$: Observable<boolean> = this.store.select(Selectors.selectIsError);
  state$: Observable<PageDataState<{ tokenName: string }, CryptotokenKey[]>> =
    this.store.select(Selectors.selectPageDataState);

  isDeleting$: Observable<boolean> = this.store.select(
    CryptotokenKeyDeleteSelectors.isDeleting,
  );

  ensure(tokenName: string, options?: { suppressErrorNotification?: boolean }) {
    this.store.dispatch(
      Actions.ensure({
        dataParams: { tokenName },
        suppressErrorNotification: options?.suppressErrorNotification,
      }),
    );
  }

  clear() {
    this.store.dispatch(Actions.clear());
  }

  transform(transformation: (data: CryptotokenKey[]) => CryptotokenKey[]) {
    this.store.dispatch(Actions.transform({ transformation }));
  }

  delete(ctKey: CryptotokenKey) {
    this.store.dispatch(CryptotokenKeyDeleteActions.delete({ item: ctKey }));
  }
}
